import React, { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';

import { useGlobalContext } from './GlobalContext';
import DashboardPiutang from './form/PiutangDashboard';
import DashboardSimpanan from './form/SimpananDashboard';
import Login from './form/Login';
import DashboardHome from './form/DashboardHome';
import ProtectedLayout from './componen/ProtectedLayout';
import PiutangNonLunas from './form/PiutangNonLunas';

import Home from './form/Dashboard';
import ListUser from './form/ListUser';
import Role from './form/Role';
import RoleHalaman from './form/RoleHalaman';
import ListKelompok from './form/ListKelompok';
import ListAnggota from './form/ListAnggota';
import SetSimpanan from './form/SetSimpanan';
import SetJasaManasuka from './form/SetJasaManasuka';
import SetJasaPinjaman from './form/SetJasaPinjaman';
import Perkiraan from './form/Perkiraan';
import SetPotSukarela from './form/SetPotSukarela';

import TransaksiUspPotongan from './componen/TransaksisiUspPotongan';
import TransaksiUspUmum from './form/TransaksiUspUmum';
import TransaksiManasuka from './form/TransaksiManaSuka';
import TransaksiHariraya from './form/TransaksiHariraya';
import TransaksiRealisasi from './form/Relisasi';

import LaporanharianUSP from './form/report/HarianUSP';
import Laporanharianmanasuka from './form/report/HarianManasuka';
import HarianHariRaya from './form/report/HarianHariRaya';
import LaporanVoucherBelanja from './form/report/Harianvbelanja';
import LaporanHarianAngsuran from './form/report/HarianAngsuran';
import LaporanHarianAngsuran2 from './form/report/HarianAngsuran2';

import MutasiSimpUSP from './form/report/MutasiSimpUSP';
import MutasiManasuka from './form/report/MutasiManasuka';
import MutasiHariRaya from './form/report/MutasiHariRaya';
import MutasiAngsuran from './form/report/MutasiAngsuran';
import MutasiPotongan from './form/report/MutasiPotongan';
import MutasiTunggakan from './form/report/MutasiTunggakan';
import MutasiVoucher from './form/report/MutasiVoucher';
import MutasiRealisasi from './form/report/MutasiRealisasi';

import ProsesManasuka from './form/ProsesManasuka';
import ProsesHariraya from './form/ProsesHariraya';
import EntriJurnal from './form/EntriJurnal';
import Potongan from './form/Potongan';
import DaftarAngsuran from './form/DaftarAngsuran';
import DaftarSimpManasuka from './form/DaftarSimpManasuka';
import DaftarSimpSaham from './form/DaftarSimpSaham';
import TutupBulan from './form/TutupBulan';
import KeperiodeLalu from './form/KeperiodeLalu';
import TransferUsp from './form/TransferUsp';
import TransferAngsuran from './form/TransferAngsuran';
import TransferManasuka from './form/TransferManasuka';
import TransferHariRaya from './form/TransferHariRaya';
import TutupAkuntansi from './form/TutupAkuntansi';
import ReprosesJurnal from './form/ReprosesJurnal';
import DaftarJurnal from './form/DaftarJurnal';

import Laporanjurnal from './form/report/LaporanJurnal';
import LapBukuBesar from './form/report/LapBukuBesar';
import RugiLaba from './form/report/RugiLaba';
import LaporanNeraca from './form/report/LaporanNeraca';


import { GlobalProvider } from './GlobalContext';

const AuthGate = ({ children }) => {
  const navigate = useNavigate();
  const { api } = useGlobalContext();

  const [checking, setChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {    
    let mounted = true;   
    const checkAuth = async () => {
      try {
        const data = localStorage.getItem("pengguna");
        if (!data) {
          if (mounted) {
            setIsValid(false);
            setChecking(false);
          }

          navigate("/login", { replace: true });
          return;
        }

        await api.get("/api/auth/me");
        if (mounted) {
          setIsValid(true);
          setChecking(false);
        }       
      } catch (error) {
        console.error('Auth check gagal:', error);
        if (mounted) {
          setIsValid(false);
          setChecking(false);
          // Hapus data user yang hanya digunakan frontend
          localStorage.removeItem("pengguna");
          localStorage.removeItem("kode");
          localStorage.removeItem("koderole");
        }
        //localStorage.removeItem('pengguna');
        navigate('/login', { replace: true });
      } finally {
        if (mounted) {
          setChecking(false);
        }
      }  
    };
     
    checkAuth();

    return () => {
      mounted = false;
    };

  }, [navigate,api]);

  if (checking) {
    return <div>Memeriksa login...</div>;
  }

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  return children;

};

function App() {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <Routes>
          {/* Login Page */}
          <Route path="/login" element={<Login />} />

          {/* Protected Area */}
          <Route
            path="/"
            element={
              <AuthGate>
                <ProtectedLayout />
              </AuthGate>
            }
          >
            {/* Dashboard & Setup */}
            <Route path="dashboard" element={<Home/>} />
            <Route path="dashboard2" element={<DashboardHome />} />
            <Route path="/dashboard/piutang" element={<DashboardPiutang />} />
            <Route path="/dashboard/simpanan" element={<DashboardSimpanan />} />
            <Route path="/piutangnonlunas" element={<PiutangNonLunas />} />      
            <Route path="role" element={<Role />} />
            <Route path="rolehalaman" element={<RoleHalaman />} />
            <Route path="daftaruser" element={<ListUser />} />
            <Route path="daftaranggota" element={<ListAnggota />} />
            <Route path="daftarunitkerja" element={<ListKelompok />} />
            <Route path="settingsimpanan" element={<SetSimpanan />} />
            <Route path="setjasapinjaman" element={<SetJasaPinjaman />} />
            <Route path="setjasamanasuka" element={<SetJasaManasuka />} />
            <Route path="perkiraan" element={<Perkiraan />} />
            <Route path="potsimpmanasuka" element={<SetPotSukarela />} />

            {/* Transaksi */}
            <Route path="simpanangsurusp1" element={<TransaksiUspPotongan />} />
            <Route path="simpanangsurusp2" element={<TransaksiUspUmum />} />
            <Route path="transaksimanasuka" element={<TransaksiManasuka />} />
            <Route path="transaksihariraya" element={<TransaksiHariraya />} />
            <Route path="transaksirealisasi" element={<TransaksiRealisasi />} />

            {/* Laporan Harian */}
            <Route path="laporanharian1" element={<LaporanharianUSP />} />
            <Route path="laporanharianmanasuka" element={<Laporanharianmanasuka />} />
            <Route path="laporanharianhariraya" element={<HarianHariRaya />} />
            <Route path="laporanvoucherbelanja" element={<LaporanVoucherBelanja />} />            
            <Route path="laporanharianangsuran" element={<LaporanHarianAngsuran />} />
            <Route path="laporanharianangsuran2" element={<LaporanHarianAngsuran2 />} />
            

            {/* Mutasi */}
            <Route path="laporanmutasisimpananusp" element={<MutasiSimpUSP />} />
            <Route path="laporanmutasisimpmanasuka" element={<MutasiManasuka />} />
            <Route path="laporanmutasisimphariraya" element={<MutasiHariRaya />} />
            <Route path="laporanmutasivoucher" element={<MutasiVoucher />} />
            <Route path="laporanmutasiangsuran" element={<MutasiAngsuran />} />
            <Route path="mutasipotongan" element={<MutasiPotongan />} />
            <Route path="mutasitunggakan" element={<MutasiTunggakan />} />
            <Route path="mutasirealisasi" element={<MutasiRealisasi />} />
            <Route path="realisasipinjaman" element={<MutasiRealisasi />} />
            
            {/* Proses & Jurnal */}
            <Route path="prosesmanasuka" element={<ProsesManasuka />} />
            <Route path="proseshariraya" element={<ProsesHariraya />} />
            <Route path="jurnal" element={<EntriJurnal />} />
            <Route path="laporanjurnal" element={<Laporanjurnal />} />
            <Route path="lapbukubesar" element={<LapBukuBesar />} />
            <Route path="rugilaba" element={<RugiLaba />} />
            <Route path="potongan" element={<Potongan />} />
            <Route path="daftarangsuran" element={<DaftarAngsuran />} />
            <Route path="daftarsimpmanasuka" element={<DaftarSimpManasuka />} />
            <Route path="daftarsimpsaham" element={<DaftarSimpSaham />} />
            <Route path="tutupbulan" element={<TutupBulan />} />
            <Route path="kebulanlalu" element={<KeperiodeLalu />} />
            <Route path="transferusp" element={<TransferUsp />} />
            <Route path="transferangsuran" element={<TransferAngsuran />} />
            <Route path="transfermanasuka" element={<TransferManasuka />} />
            <Route path="transferhariraya" element={<TransferHariRaya />} />  
            <Route path="laporanneraca" element={<LaporanNeraca />} /> 
            <Route path="tutupakuntansi" element={<TutupAkuntansi />} />
            <Route path="reprosesjurnal" element={<ReprosesJurnal />} />
            <Route path="daftarjurnal" element={<DaftarJurnal />} />

          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;
